import * as React from 'react';
import { useState, useEffect, useRef } from 'react';

//import React from 'react';
import { MapContainer, ScaleControl, Polyline, Marker, Polygon, Circle, Popup, LayersControl, TileLayer, useMapEvents, Tooltip, GeoJSON, useMap } from 'react-leaflet';
import L from 'leaflet';
import '!style-loader!css-loader!react-leaflet-fullscreen/dist/styles.css';
import MainPlayer from './MainPlayer';
import LabelMarker from './LabelMarker';
import BuoyLines from './BuoyLines';
import VirtualBuoy from './VirtualBuoy';
import Emergency from './Emergency';
import Online from './online';
import MeasureDistance from '../measurement_distance/MeasureDistance'
import Fullscreen from 'react-leaflet-fullscreen-plugin';
import '!style-loader!css-loader!./map.css';
import '!style-loader!css-loader!leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import Control from './Control';

import axios from 'axios';
import MyLocationIcon from "../../images/my-location.svg"; // SVGファイルをインポート

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});

export const mapType = {
  osmBlackAndWhite: "モノクロ",
  osmMapnik: "カラー",
  gsi: "国土地理院",
  gsiPic: "国土地理院(写真)",
  mapboxSatellite: "Mapbox航空写真",
}


// Leaflet のデフォルトアイコンの修正
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

//export default class MapBrowser extends React.Component {
export default function MapBrowser(props) {
  const mapRef = useRef();
  const { center, lines, circles, polygons, vbuoys, geojsons, emergencies, formlines, formcircles, formpolygons, formvbuoys, measure_distance, online, knot, mapboxOption, mapboxAccessToken } = props;
  const f_lines = formlines ? formlines : []
  const f_circles = formcircles ? formcircles : []
  const f_polygons = formpolygons ? formpolygons : []
  const f_vbuoys = formvbuoys ? formvbuoys : []
  const [pos, setPos] = useState(props.pos);
  const [zoom, setZoom] = useState(props.zoom);
  const height = props.height ? props.height : '90vh';
  const [show_distance_devices, setShowDistanceDevices] = useState([]);
  const ems = emergencies ? emergencies : []
  const maxNativeZoom = 18
  const maxZoom = 22
  const [contourData10, setContourData10] = useState(null);
  const [position, setPosition] = useState(null);
  const [accuracy, setAccuracy] = useState(9999);
  const [mapInstance, setMapInstance] = useState(null);
  const [isTracking, setIsTracking] = useState(false);
  const watchId = useRef(null);

  useEffect(() => {
    const fetchContourData = async () => {
      const apiKey = '0e83ad5d93214e04abf37c970c32b641';
      const url = `https://api.msil.go.jp/depth-contour/v2/MapServer/10/query?f=geojson&geometryType=esriGeometryEnvelope&spatialRel=esriSpatialRelIntersects&units=esriSRUnit_Meter&returnGeometry=true`;
      try {
        const response = await axios.get(url, {
          headers: {
            'Ocp-Apim-Subscription-Key': apiKey
          }
        });
        console.log(response.data)
        setContourData10(response.data);
      } catch (error) {
        console.error('Error fetching contour data:', error);
      }
    };
    //fetchContourData();
  }, []);

  // 現在位置の更新処理
  const updatePosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude, accuracy } = pos.coords;
          setPosition([latitude, longitude]);
          setAccuracy(accuracy)
          // GPSの誤差を出力
          console.log(`現在位置: 緯度 ${latitude}, 経度 ${longitude}`);
          console.log(`GPSの誤差: ±${accuracy}メートル`);
        },
        (error) => {
          console.error("位置情報の取得に失敗しました:", error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      alert("このブラウザは位置情報APIに対応していません。");
    }
  };

  // トラッキングモードの切り替え
  const handleTrackingToggle = () => {
    if (isTracking) {
      // トラッキングモード解除
      if (watchId.current !== null) {
        navigator.geolocation.clearWatch(watchId.current);
        watchId.current = null;
      }
      setIsTracking(false);
    } else {
      // トラッキングモード開始
      updatePosition(); // 最初に現在位置を取得
      watchId.current = navigator.geolocation.watchPosition(
        (pos) => {
          const { latitude, longitude, accuracy } = pos.coords;
          setPosition([latitude, longitude]);
          setAccuracy(accuracy)
        },
        (error) => {
          console.error("位置情報の取得に失敗しました:", error);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 0,
        }
      );
      setIsTracking(true);
    }
  };

  // 地図移動イベントでトラッキングモードを解除
  useEffect(() => {
    if (mapInstance) {
      const handleMapMove = () => {
        if (isTracking) {
          handleTrackingToggle(); // トラッキングモード解除
        }
      };
      mapInstance.on("dragstart", handleMapMove);
      return () => {
        mapInstance.off("dragstart", handleMapMove);
      };
    }
  }, [mapInstance, isTracking]);

  // デバイス追跡: focusPositionが更新されたら地図の中央を移動
  useEffect(() => {
    if (mapInstance && props.focusPosition && props.focusPosition[0] > 0) {
      mapInstance.setView(props.focusPosition, mapInstance.getZoom(), { animate: true });
    }
  }, [mapInstance, props.focusPosition]);

  // 現在位置が更新されたらコールバックを実行
  useEffect(() => {
    if (position && props.onLocationFound) {
      props.onLocationFound(position[0], position[1]);
    }
  }, [position]);

  useEffect(() => {
    const zoomValue = localStorage.getItem('zoom');
    if (zoomValue) {
      setZoom(Number(zoomValue));
    }
  }, []);

  const handleShowDistanceDevices = (device) => {
    let d = show_distance_devices;
    if (d.length > 0) {
      let prev = d[d.length - 1];
      if (prev.deviceId == device.deviceId) {
        setShowDistanceDevices(d.slice(0, -1))
      } else {
        setShowDistanceDevices(d.concat(device))
      }
    } else {
      setShowDistanceDevices(d.concat(device))
    }
  }

  const initShowDistanceDevices = () => {
    setShowDistanceDevices([])
  }


  //スイッチオフでクリアする
  useEffect(() => {
    if (measure_distance == false) {
      initShowDistanceDevices();
    }
  }, [measure_distance]);


  function MyComponent() {
    const map = useMapEvents({
      //Geofenceの登録時のマップクリックイベントを取得
      click: (e) => {
        if (props.handleClick) {
          props.handleClick(e);
        }
      },
      // zoomが変更された時に実行するコールバック関数
      zoomend: () => {
        const zoomLevel = map.getZoom();
        setZoom(zoomLevel); // state更新をしておかないと、再レンダリング時のmap.setZoom(zoom)の実行で以前のzoomレベルに戻ってしまう。
        localStorage.setItem('zoom', zoomLevel);
      },
      baselayerchange: (e) => {
        if (props.setMapType) {
          props.setMapType(e.name);
        }
      },
    });
    // zoomなどの情報はmapインスタンスに直接アクセスしないと変更できない。
    map.setZoom(zoom);

    // トラッキングモード中のみ現在位置に追従（ユーザーがスクロールするとisTrackingがfalseになり追従停止）
    useEffect(() => {
      if (position && map && isTracking) {
        map.flyTo(position, map.getZoom());
      }
    }, [position, isTracking]);

    return null;
  }

  const options = {
    position: 'topleft', // change the position of the button can be topleft, topright, bottomright or bottomleft, default topleft
    title: 'Show me the fullscreen !', // change the title of the button, default Full Screen
    titleCancel: 'Exit fullscreen mode', // change the title of the button when fullscreen is on, default Exit Full Screen
    content: null, // change the content of the button, can be HTML, default null
    forceSeparateButton: true, // force separate button to detach from zoom buttons, default false
    forcePseudoFullscreen: true, // force use of pseudo full screen even if full screen API is available, default false
    fullscreenElement: false, // Dom element to render in full screen, false by default, fallback to map._container
  };

  let deviceMap = [];
  if (props.deviceMap)
    deviceMap = props.deviceMap;

  const currentMap = props.mapType ? props.mapType : mapType.osmBlackAndWhite;

  return (
    <>
      {/* 現在位置取得ボタン */}
      <MapContainer center={center} zoom={zoom} maxZoom={maxZoom} style={{ height: height }}
        whenCreated={setMapInstance} // マップインスタンスを取得
      >
        <MyComponent />
        <ScaleControl className="zoom" position="bottomleft" imperial={false} />

        <Fullscreen
          eventHandlers={{
            enterFullscreen: (event) => console.log('entered fullscreen', event),
            exitFullscreen: (event) => console.log('exited fullscreen', event),
          }}
          {...options}
        />

        <Marker icon={DefaultIcon} position={center}>
          <Popup direction={'top'} >拠点の位置</Popup>
        </Marker>

        <Control>
          {props.topright}
        </Control>

        {/* Lines */}
        {lines.map((positions) => (
          <Polyline color={positions.color_code} weight={3} opacity={0.8} key={Math.random()} positions={positions.vertexes}>
            <LabelMarker position={positions.vertexes} name={positions.name} color={positions.color_code} type={"l"} />
          </Polyline>
        ))}
        {f_lines.map((positions) => (
          <Polyline color={positions.color_code} weight={5} opacity={0.9} key={Math.random()} positions={positions.vertexes} />
        ))}

        {/* Polygons */}
        {polygons.map((positions) => (
          <Polygon key={Math.random()} color={positions.color_code} weight={1} opacity={0.6} positions={positions.vertexes} >
            <LabelMarker position={positions.vertexes} name={positions.name} color={positions.color_code} type={"p"} />
          </Polygon>
        ))}
        {f_polygons.map((positions) => (
          <Polygon key={Math.random()} color={positions.color_code} weight={3} opacity={0.9} positions={positions.vertexes} />
        ))}

        {/* Circles */}
        {circles.map((circle) => (
          <Circle color={circle.color_code} fillColor={circle.color_code} weight={1} opacity={0.6} key={Math.random()} center={circle.vertexes.center} radius={circle.vertexes.radius} >
            <LabelMarker position={circle.vertexes.center} name={circle.name} color={circle.color_code} type={"c"} />
          </Circle>
        ))}
        {f_circles.map((circle) => (
          <Circle color={circle.color_code} fillColor={circle.color_code} weight={3} opacity={0.9} key={Math.random()} center={circle.vertexes.center} radius={circle.vertexes.radius} />
        ))}

        {/* Vbuoys */}
        {vbuoys.map((circle) => (
          <div key={circle.id}>
            <Circle color={circle.color_code} fillColor={circle.color_code} key={Math.random()} center={circle.vertexes.center} radius={circle.vertexes.radius} >
              <LabelMarker position={circle.vertexes.center} name={circle.name} color={circle.color_code} type={"c"} />
            </Circle>
            <VirtualBuoy key={Math.random()} id={circle.id} name={circle.name} center={circle.vertexes.center}
              measure_distance={props.measure_distance}
              show_label={props.show_label}
              handleShowDistanceDevices={handleShowDistanceDevices}
            />
          </div>
        ))}

        {/* GeoJson */}
        {geojsons.map((geojson, geojsonIndex) => {
          const color = geojson.color_code; // GeoJSON全体の色
          const pointToLayerWithColor = (feature, latlng) => {
            const text_only = feature.properties['text-only'];
            const name = feature.properties?.name;
            if (text_only) {
              return L.marker(latlng, {
                icon: L.divIcon({
                  className: 'custom-text-only',
                  html: `<span style="color:${color}; opacity:1.0; font-size:10pt; white-space:nowrap;">${name}</span>`,
                  iconSize: null,
                  iconAnchor: [0, 0],
                }),
                interactive: false,
              });
            } else {
              // 通常のマーカー処理
              const iconUrl = feature.properties['icon-image-url'];
              const markerIcon = iconUrl
                ? L.icon({
                  iconUrl,
                  iconSize: [30, 30],
                  iconAnchor: [15, 30],
                })
                : DefaultIcon;

              const marker = L.marker(latlng, { icon: markerIcon });

              const name = feature.properties?.name;
              if (name) {
                marker.bindTooltip(`<span style="color: ${color};">${name}</span>`, {
                  permanent: true,
                  direction: 'bottom',
                  offset: [0, 0],
                  className: 'leaflet-tooltip-own',
                });
              }

              const imageUrl = feature.properties?.['image-url'];
              if (imageUrl) {
                const popupContent = `
                  ${name ? `<strong>${name}</strong><br/>` : ''}
                  <img src="${imageUrl}" width="200" style="display:block; margin-top:5px;" />
                `;
                marker.bindPopup(popupContent, {
                  autoClose: false,
                  closeOnClick: false,
                });
              }

              return marker;
            }
          };

          return (
            <GeoJSON
              key={`geojson-${geojson.id || geojsonIndex}`}
              data={JSON.parse(geojson.vertexes)}
              style={{ color: color, opacity: 0.6 }}
              pointToLayer={pointToLayerWithColor}
            />
          );
        })}
        {/* 海しるAPI */}
        {contourData10 && <GeoJSON data={contourData10} style={{ "color": "#0000ff", "opacity": 0.6 }} />}

        {/* Emergency */}
        {ems.map((e) => (
          <Emergency is_completed={e.is_completed} lat={e.lat} long={e.long} phone_number={e.phone_number} created_at={e.created_at} location={e.location} triage={e.triage} comment={e.comment} id={e.id} history={e.history} />
        ))}

        {f_vbuoys.map((circle) => (
          <div key={circle.id}>
            <Circle color={circle.color_code} fillColor={circle.color_code} key={Math.random()} center={circle.vertexes.center} radius={circle.vertexes.radius} />
            <VirtualBuoy key={Math.random()} id={circle.id} name={circle.name} center={circle.vertexes.center}
              measure_distance={props.measure_distance}
              show_label={props.show_label}
              handleShowDistanceDevices={handleShowDistanceDevices}
            />
          </div>
        ))}


        {/* Marker */}
        {lines.map((m) => (m.vertexes.map((p) => (
          props.showPins && <Marker color={'#A4C520'} key={Math.random()} icon={DefaultIcon} position={p} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))))}
        {polygons.map((m) => (m.vertexes.map((p) => (
          props.showPins && <Marker key={Math.random()} icon={DefaultIcon} position={p} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))))}
        {circles.map((m) => (
          props.showPins && <Marker color={'#EDAD0B'} key={Math.random()} icon={DefaultIcon} position={m.vertexes.center} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))}
        {vbuoys.map((m) => (
          props.showPins && <Marker color={'#EDAD0B'} key={Math.random()} icon={DefaultIcon} position={m.vertexes.center} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))}
        {f_lines.map((m) => (m.vertexes.map((p) => (
          props.showPins && <Marker color={'#A4C520'} key={Math.random()} icon={DefaultIcon} position={p} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))))}
        {f_polygons.map((m) => (m.vertexes.map((p) => (
          props.showPins && <Marker key={Math.random()} icon={DefaultIcon} position={p} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))))}
        {f_circles.map((m) => (
          props.showPins && <Marker color={'#EDAD0B'} key={Math.random()} icon={DefaultIcon} position={m.vertexes.center} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))}
        {f_vbuoys.map((m) => (
          props.showPins && <Marker color={'#EDAD0B'} key={Math.random()} icon={DefaultIcon} position={m.vertexes.center} >
            <Popup direction={'top'} > <a href={m.uri && m.uri.js + '/edit'}>{m.name}</a>  </Popup>
          </Marker>
        ))}


        {/* Player */}
        {Object.keys(deviceMap).map((key, index) => (
          <MainPlayer key={deviceMap[key].id}
            device={deviceMap[key]}
            show_label={props.show_label}
            measure_distance={props.measure_distance}
            handleShowDistanceDevices={handleShowDistanceDevices}
            show_line={props.show_line}
            max_line_length={props.max_line_length}
            all_lines={deviceMap[key].all_lines}
            knot={knot}
          />
        ))}

        {/* Start Goal Line */}
        <BuoyLines devices={deviceMap} />


        {/* MeasureDistance */}
        <MeasureDistance devices={show_distance_devices} isshow={props.measure_distance} />

        <Online online={online} />

        <button
          type="button"
          onClick={handleTrackingToggle}
          style={{
            position: "absolute",
            top: "20px",
            left: "10px",
            zIndex: 1000,
            backgroundColor: isTracking ? "#00ffff" : "#ffffff",
            color: "white",
            border: "none",
            borderRadius: "8px", // 四角い形に変更
            width: "35px",
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            transition: "transform 0.2s, box-shadow 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          onMouseDown={(e) => (e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.2)")}
          onMouseUp={(e) => (e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)")}
        >
          {/* SVGファイルを画像として使用 */}
          <img
            src={MyLocationIcon}
            alt="現在位置"
            style={{ width: "24px", height: "24px" }}
          />
        </button>


        <LayersControl position="bottomright">
          <LayersControl.BaseLayer checked={currentMap === mapType.osmBlackAndWhite} name={mapType.osmBlackAndWhite}>
            <TileLayer
              attribution='&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">国土地理院</a>'
              url="https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
              className="map-tiles-grayscale"
              maxZoom={maxZoom}
              maxNativeZoom={maxNativeZoom}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer checked={currentMap === mapType.osmMapnik} name={mapType.osmMapnik}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              maxZoom={maxZoom}
              maxNativeZoom={maxNativeZoom}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer checked={currentMap === mapType.gsi} name={mapType.gsi}>
            <TileLayer
              attribution='&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">国土地理院</a>'
              url="https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png"
              maxZoom={maxZoom}
              maxNativeZoom={maxNativeZoom}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer checked={currentMap === mapType.gsiPic} name={mapType.gsiPic}>
            <TileLayer
              attribution='&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">国土地理院</a>'
              url="https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg"
              maxZoom={maxZoom}
              maxNativeZoom={maxNativeZoom}
            />
          </LayersControl.BaseLayer>
          {mapboxOption && mapboxAccessToken && (
            <LayersControl.BaseLayer checked={currentMap === mapType.mapboxSatellite} name={mapType.mapboxSatellite}>
              <TileLayer
                attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a>'
                url={`https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=${mapboxAccessToken}`}
                maxZoom={maxZoom}
                maxNativeZoom={maxNativeZoom}
              />
            </LayersControl.BaseLayer>
          )}
        </LayersControl>

        {position && (
          <>
            <Marker position={position} icon={L.divIcon({ className: isTracking ? "custom-marker-tracking" : "custom-marker" })}>
              <Popup>現在位置</Popup>
            </Marker>
            <Circle
              center={position}
              radius={accuracy}
              pathOptions={{
                color: isTracking ? "#007BFF" : "#999999",
                fillColor: isTracking ? "#007BFF" : "#999999",
                fillOpacity: 0.15,
              }}
            />
          </>

        )}
      </MapContainer>
    </>
  );
}
